<template>
  <div
    class="dropdown-menu-content"
  >
    <div
      class="dropdown-menu"
      :aria-hidden="false"
      :style="dropdownMenuStyle"
    >
      <slot name="dropdownContent">
        <ul>
          <slot />
        </ul>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    alignRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    dropup: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    dropdownMenuStyle() {
      let style = '';

      if (this.alignRight) {
        style += 'right: 0;';
      } else {
        style += 'left: 0;';
      }

      if (this.dropup) {
        style += 'bottom: 100%;';
      } else {
        style += 'top: 105%;';
      }

      if (this.fullWidth) {
        style += 'min-width: 100%;';
      }

      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
  .dropdown-menu-content {
    display: inline-block;
    position: relative;
    white-space: nowrap;
  }

  .chevron-down-icon {
    color: var(--blue-dark);
  }

  .dropdown-menu {
    position: absolute;
    border: 1px solid var(--gray-lighter);
    background-color: #fff;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    border-radius: 0.25rem;
    z-index: 3;

    &[aria-hidden="true"] {
      display: none;
    }

    a,
    .btn {
      display: block;
      width: 100%;
      padding: 6px 8px;
      color: var(--gray-darker);
      font-size: 0.8rem;

      &:focus,
      &:hover {
        color: var(--gray-darker);
        background-color: var(--gray-lightest);
      }
    }
  }

  ul {
    margin: 0;
    padding-left: 0;
    list-style: none;
    text-align: center;
  }

  li + li {
    border-top: 1px solid var(--gray-lighter);
  }
</style>
